// src/app/guards/auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): boolean {
    const token = this.auth.getToken();
    console.log('🔐 Checking AuthGuard token:', token);

    if (token) {
      return true;
    }

    console.warn('🚫 No token found. Redirecting to /login...');
    this.router.navigate(['/login']);
    return false;
  }
}
